export default __webpack_public_path__ + "static/char-s-46-zh-Hans-bc3d44dad4b89d670821e27261a9834d.png";